import { ChangeDetectionStrategy, Component, inject } from "@angular/core";
import { InhabitantDemographyComponent } from "src/app/ev-map/estate-map/estate-statistics/demography/inhabitant-demography/inhabitant-demography.component";
import { RightSidebarOptions, RightSidebarService } from "src/services/right-sidebar.service";
import { EvAuthorizationService } from "src/util/auth0/ev-auth.service";
import { EVServiceType } from "src/util/auth0/models/evServiceType.enum";

@Component({
    selector: "new-dwelling-statistics",
    imports: [InhabitantDemographyComponent],
    templateUrl: "./new-dwelling-statistics.component.html",
    styleUrl: "./new-dwelling-statistics.component.scss",
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NewDwellingStatisticsComponent {
    private readonly rightSidebarService = inject(RightSidebarService);
    private readonly authorizationService = inject(EvAuthorizationService);

    hasDemographicsRole = this.authorizationService.hasPermissionSignal(EVServiceType.EvWeb_Demography, true, false);

    currentPane: StatisticPanes = StatisticPanes.none;
    StatisticPanes = StatisticPanes;

    onCloseStatistics(): void {
        this.rightSidebarService.toggleSidebarVisibility(RightSidebarOptions.Closed);
    }

    showStatisticsPane(pane: StatisticPanes): void {
        this.currentPane = pane;
    }
}

export enum StatisticPanes {
    none,
    sales,
    demographyInhabitants,
}
